import { P2GBox, P2GGrid, P2GSticky } from '@parcel2go/core-ui';
import { ProgressBars } from './progress-bars';

export declare type ProgressBarType = {
  text: string;
};

export interface ProgressBarProps {
  progressBars: ProgressBarType[];
  currentIndex: number;
  onStepClick?: (step: number) => void;
  formId?: string;
}

export const ProgressBar = ({ progressBars, currentIndex, onStepClick, formId }: ProgressBarProps) => {
  return (
    <P2GSticky align="top" backgroundColor="#f5f5f5" style={{ position: 'sticky', zIndex: 3, top: 0 }}>
      <P2GBox mt={1} pb={2}>
        <nav>
          <P2GGrid container spacing={1} alignItems="center">
            <ProgressBars
              formId={formId}
              progressBars={progressBars}
              currentIndex={currentIndex}
              onStepClick={onStepClick}
            />
          </P2GGrid>
        </nav>
      </P2GBox>
    </P2GSticky>
  );
};
